import { render, staticRenderFns } from "./SurgApprove.vue?vue&type=template&id=e112ccea"
import script from "./SurgApprove.vue?vue&type=script&lang=js"
export * from "./SurgApprove.vue?vue&type=script&lang=js"
import style0 from "./SurgApprove.vue?vue&type=style&index=0&id=e112ccea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports